import React from "react";

interface PageHeadingProps {
  title?: string;
  subtext?: string;
}

const PageHeading = ({ title, subtext }: PageHeadingProps) => {
  return (
    <section className="page-title-wrap">
      <article className="text-cell">
        <h1 className="page-title">{title}</h1>
        {subtext && <p className="page-subtext">{subtext}</p>}
      </article>
    </section>
  );
};

export default PageHeading;
